export default __webpack_public_path__ + "static/media/promocode_pc_Hk.e340a2a8.webp";